export default "__VITE_ASSET__gk_O_ou5__"